module.exports = __webpack_public_path__ + "static/media/Brasao_sspds_2022_lateral.af710bd6.png";